export default __webpack_public_path__ + "static/media/soundwave.f3e1d29d.svg";